import React, { useEffect, useState } from "react";
import "react-date-range/dist/styles.css"; // main style file for the datepicker
import "../../../../../../Assets/Styles/DatePickerTheme.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import { formatDate } from "../../../../../../Helper_functions";

const RangeDatepicker = (props) => {
  const [DaysDifference, setDatysDifference] = useState(0);
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [SelectedDate, setSelectedDate] = useState({
    start: "",
    end: "",
  });
  const [PrevDate, setPrevDate] = useState({});
  const displayDate = (StartDate, EndDate) => {
    var Differens = EndDate - StartDate;
    var DaysDifference = Math.floor(Differens / 1000 / 60 / 60 / 24);
    Differens -= DaysDifference * 1000 * 60 * 60 * 24;
    setDatysDifference(DaysDifference + 1);
  };
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0]?.label_value;
  };

  const handleChange = (Item) => {
    setState([Item.selection]);
    let StartDate = new Date(Item.selection.startDate).getTime();
    let EndDate = new Date(Item.selection.endDate).getTime();
    setSelectedDate({
      start: formatDate(StartDate),
      startTimestap: StartDate,
      end: formatDate(EndDate),
      endTimestamp: EndDate,
    });
    displayDate(StartDate, EndDate);
    props.SaveSelectedDate(StartDate, EndDate);
  };
  const resetDatePicker = () => {
    document.getElementsByClassName("rdrStaticRangeLabel")[0].click();
    setTimeout(() => {
      document.getElementById("displayed-date").innerHTML =
        translateText("date_from_to");
      setSelectedDate({
        start: "",
        end: "",
      });
      props.Apply(true); // true means date is reset and no date value will be considered in the request
    }, 50);
  };
  const closeDatepicker = () => {
    if (
      SelectedDate.start === PrevDate.start &&
      SelectedDate.end === PrevDate.end
    ) {
      setSelectedDate(PrevDate);
    } else {
      resetDatePicker();
    }
    props.Close();
  };
  const toggleApply = () => {
    setPrevDate(SelectedDate);
    props.Apply(false, SelectedDate);
  };
  const handleShowMonths = () => {
    if (window.innerWidth <= 1024) {
      return 1;
    } else {
      return 2;
    }
  };

  useEffect(() => {
    if (props.DatePickerIsOpen) {
      const el = document.querySelector(".rdrStaticRangeSelected");
      const RangeToTop = el?.getBoundingClientRect()?.top;
      document.getElementsByClassName("rdrStaticRangeLabel")[0].innerHTML =
        translateText("today") || "";
      el?.click();
      if (window.innerWidth <= 450 && RangeToTop > 8) {
        // if already at top, we don't need to execute
        el.style.top = `-${el.getBoundingClientRect().top - 8}px`; // 8px for padding top
      }
    }
  }, [props.DatePickerIsOpen]);

  return (
    <React.Fragment>
      {window.innerWidth > 450 ? (
        <div className="outline" onClick={() => closeDatepicker()}></div>
      ) : null}
      <div className="range-datepicker">
        {window.innerWidth > 450 ? (
          <React.Fragment>
            <DateRangePicker
              onChange={(Item) => handleChange(Item)}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={handleShowMonths()}
              ranges={state}
              direction="horizontal"
              maxDate={new Date()}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <section className="datepicker-head-mobile">
              <i className="feather-x" onClick={() => closeDatepicker()}></i>
              {SelectedDate.start.length === 0 ? (
                <p>{formatDate(new Date().getTime())}</p>
              ) : (
                <p>
                  {formatDate(new Date(SelectedDate.startTimestap).getTime())}
                </p>
              )}
            </section>
            <DateRangePicker
              onChange={(Item) => handleChange(Item)}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={state}
              direction="vertical"
              maxDate={new Date()}
              scroll={{ enabled: true }}
            />
          </React.Fragment>
        )}
        <section className="datepicker-footer">
          {SelectedDate.start.length === 0 && window.innerWidth > 450 ? (
            <p>{translateText("date_from_to")}</p>
          ) : (
            <React.Fragment>
              {window.innerWidth > 450 ? (
                <p onClick={() => props.Close()}>
                  {SelectedDate.start} - {SelectedDate.end} ({DaysDifference}{" "}
                  {translateText("days")})
                </p>
              ) : null}
            </React.Fragment>
          )}
          <div className="datepicker-actions">
            <section
              onClick={() => resetDatePicker()}
              className={
                SelectedDate.start.length === 0
                  ? "reset disabled-reset"
                  : "reset"
              }
            >
              {translateText("reset")}
            </section>
            <section
              onClick={() => toggleApply()}
              className={
                SelectedDate.start.length === 0
                  ? "apply disabled-apply"
                  : "apply"
              }
            >
              {translateText("apply")}
            </section>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default RangeDatepicker;
